import { SettingsSubModule } from '../utils/settings-sub-module';
import { SettingValue } from '../utils/setting-value';
import { SettingsModule } from '../utils/settings-module';

export namespace WorkflowFields {
  export enum CommonField {
    QueryReminderDateRange = 'Workflow.QueryReminderDateRange',
    DueDateRange = 'Workflow.DueDateRange',
    ReminderDateRange = 'Workflow.ReminderDateRange',
    AutoReleaseDateRange = 'Workflow.AutoReleaseDateRange',
    DueDate = 'Workflow.DueDate',
    QueryReminderDays = 'Workflow.QueryReminderDays',
    AutoReleaseDate = 'Workflow.AutoReleaseDate',
    EscalationFrequency = 'Workflow.EscalationFrequency',
    TestModeEnabled = 'Workflow.TestModeEnabled',
    EscalationFrequencyRange = 'Workflow.EscalationFrequencyRange',
    ReminderDates = 'Workflow.ReminderDates',
    ClarificationAutoReleasePeriod = 'Workflow.ClarificationAutoReleasePeriod',
    EnableEmailAttachment = 'Workflow.EnableEmailAttachment',
    DefaultWorkflowAttachmentMode = 'Workflow.DefaultWorkflowAttachmentMode',
    DocumentFinalStatus = 'Workflow.DocumentFinalStatus',
    DocumentRejectedStatus = 'Workflow.DocumentRejectedStatus',
    IncidentFinalStatus = 'Workflow.IncidentFinalStatus',
    IncidentRejectedStatus = 'Workflow.IncidentRejectedStatus',
    CapaFinalStatus = 'Workflow.CapaFinalStatus',
    CapaRejectedStatus = 'Workflow.CapaRejectedStatus',
    ActionItemFinalStatus = 'Workflow.ActionItemFinalStatus',
    ActionItemRejectedStatus = 'Workflow.ActionItemRejectedStatus',
    AllowAdminAdvancedManagementOperations = 'Workflow.AllowAdminAdvancedManagementOperations',
    DefaultNextReviewPeriod = 'Workflow.DefaultNextReviewPeriod',
    CollaborationReviewDefaultDueDatePeriod = 'Workflow.CollaborationReviewDefaultDueDatePeriod',
  }
}

class CommonConfig extends SettingsSubModule {
  @SettingsSubModule.value(WorkflowFields.CommonField.QueryReminderDateRange, '10;5;3')
  queryReminderDateRange: SettingValue<string>;
  @SettingsSubModule.value(WorkflowFields.CommonField.DueDateRange, '10;5;3') dueDateRange: SettingValue<string>;
  @SettingsSubModule.value(WorkflowFields.CommonField.ReminderDateRange, '5;3;2;1')
  reminderDateRange: SettingValue<string>;
  @SettingsSubModule.value(WorkflowFields.CommonField.AutoReleaseDateRange, '11;6;4')
  autoReleaseDateRange: SettingValue<string>;
  @SettingsSubModule.value(WorkflowFields.CommonField.DueDate, 0) dueDate: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.QueryReminderDays, '') queryReminderDays: SettingValue<string>;
  @SettingsSubModule.value(WorkflowFields.CommonField.AutoReleaseDate, 0) autoReleaseDate: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.EscalationFrequency, 0) escalationFrequency: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.TestModeEnabled, false) testModeEnabled: SettingValue<boolean>;
  @SettingsSubModule.value(WorkflowFields.CommonField.EscalationFrequencyRange, '3;2;-1')
  escalationFrequencyRange: SettingValue<string>;
  @SettingsSubModule.value(WorkflowFields.CommonField.ReminderDates, '') reminderDates: SettingValue<string>;
  @SettingsSubModule.value(WorkflowFields.CommonField.ClarificationAutoReleasePeriod, 0)
  clarificationAutoReleasePeriod: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.EnableEmailAttachment, true)
  enableEmailAttachment: SettingValue<boolean>;
  @SettingsSubModule.value(WorkflowFields.CommonField.DefaultWorkflowAttachmentMode, 0)
  defaultWorkflowAttachmentMode: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.DocumentFinalStatus, -1)
  documentFinalStatus: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.DocumentRejectedStatus, -1)
  documentRejectedStatus: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.AllowAdminAdvancedManagementOperations, '0')
  allowAdminAdvancedManagementOperations: SettingValue<string>;
  @SettingsSubModule.value(WorkflowFields.CommonField.DefaultNextReviewPeriod, 0)
  defaultNextReviewPeriod: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.CollaborationReviewDefaultDueDatePeriod, 14)
  collaborationReviewDefaultDueDatePeriod: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.IncidentFinalStatus, null)
  incidentFinalStatus: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.IncidentRejectedStatus, null)
  incidentRejectedStatus: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.CapaFinalStatus, null)
  capaFinalStatus: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.CapaRejectedStatus, null)
  capaRejectedStatus: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.ActionItemFinalStatus, null)
  actionItemFinalStatus: SettingValue<number>;
  @SettingsSubModule.value(WorkflowFields.CommonField.ActionItemRejectedStatus, null)
  actionItemRejectedStatus: SettingValue<number>;
}

export class WorkflowModule extends SettingsModule {
  @SettingsModule.value(CommonConfig) common: CommonConfig;
}
